export default {
    Email: 'ईमेल',
    ConfirmEmail: 'ईमेल की पुष्टि करें',
    Password: 'पासवर्ड',
    Verificationcode: 'सत्यापन कोड',
    AlreadyhaveaHitPawaccountLogin: 'आपके पास पहले से HitPaw खाता है? लॉग इन करें',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'साइन अप करके, आप हमारी प्रयोग की शर्तों और गोपनीयता नीति के लिए सहमति देते हैं',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'आगे बढ़कर, आप हमारी उपयोग की सेवाओं और गोपनीयता नीति से सहमत होते हैं',
    Byproceedingyouagreetoour: 'आगे बढ़कर, आप हमारी उपयोग की ',
    ServicesofUse: 'सेवा',
    and: 'ओं ',
    PrivacyPolicy: 'गोपनीयता नीति',
    last: ' से सहमत होते हैं.',
    TheEmailformatisincorrect: 'ईमेल फॉर्मेट गलत है',
    Pleaseenterthesameemailinbothfields: 'कृपया दोनों क्षेत्रों में एक ही ईमेल डालें।',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'पासवर्ड 8-50 अक्षर का होना चाहिए और इसमें निम्न में से कम से कम दो श्रेणियां होनी चाहिए: संख्या, अक्षर या विशेष वर्ण।',
    Incorrectverificationcode: 'गलत सत्यापन कोड',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'यह ईमेल पंजीकृत किया गया है, कृपया कोई दूसरा चुनें।',
    Cannotbeemptyhere: 'यहाँ खाली नहीं हो सकता।',
    Rememberme: 'मुझे याद रखें',
    ForgotPassword1: 'पासवर्ड भूल गए?',
    NotaregistereduseryetSignUp: 'अभी तक एक पंजीकृत प्रयोगकर्ता नहीं हैं? साइन अप करें',
    Notaregistereduseryet1: 'अभी तक एक पंजीकृत प्रयोगकर्ता नहीं हैं? ',
    Notaregistereduseryet2: 'साइन अप करें',
    NoaccountfoundwiththatEmailaddress: 'उस ईमेल पते के साथ कोई खाता नहीं मिला',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'आपका ईमेल या पासवर्ड गलत था। कृपया दोबारा कोशिश करें।',
    ForgotPassword2: 'पासवर्ड भूल गए',
    GetVerificationCode: 'सत्यापन कोड पाएं',
    VerifyEmail: 'ईमेल सत्यापित करें',
    Ithasbeensenttoyourmailboxpleasecheckit:
        'इसे आपके मेलबॉक्स में भेज दिया गया है, कृपया इसे देखें',
    PleaseinputEmailaddress: 'कृपया ईमेल पता डालें',
    TheEmailisnotregistered: 'ईमेल पंजीकृत नहीं है',
    Invalidverificationcodepleasereenterthecorrectone:
        'अमान्य सत्यापन कोड, कृपया सही कोड दोबारा डालें',
    Resetpassword: 'पासवर्ड रिसेट',
    Emailaddressverificationsucceeded: 'ईमेल पता सत्यापन सफल हुआ',
    Pleaseresetyourpassword: 'अपना पासवर्ड रिसेट करें',
    Enteranewpassword: 'नया पासवर्ड डालें',
    Confirm: 'पुष्टि करें',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'नया पासवर्ड 8-50 अक्षर का होना चाहिए, जो अक्षरों या संख्याओं या अक्षरों + संख्याओं के मिश्रण से बना हो',
    Passwordresetsuccessfully: 'पासवर्ड सफलतापूर्वक रिसेट हो गया',
    Name: 'नाम',
    GetCode: 'कोड प्राप्त करें',
    Loginsuccessful: 'लॉगइन सफल',
    Loginfailed: 'लॉगइन विफल',
    Signupsuccessful: 'साइन अप सफल',
    Signupfailed: 'साइन अप विफल',
    Getpassword: 'पासवर्ड पाएं',
    Authorizationhasexpiredpleaseloginagain:
        'प्रमाणीकरण समाप्त हो गया है, कृपया दोबारा लॉगइन करें।',
    Sorrysomethingwentwrongpleasetryagainlater:
        'माफ़ करें, कुछ गड़बड़ हो गयी थी, कृपया बाद में दोबारा कोशिश करें।',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'बहुत कम समय में बहुत सारे समान अनुरोध किये गए थे, कृपया बाद में दोबारा कोशिश करें।',
    Couldntfindyouraccountorthepasswordisincorrect: 'आपका खाता नहीं मिला, या पासवर्ड गलत है।',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'आप एक सशुल्क कार्यक्षमता एक्सेस करने की कोशिश कर रहे हैं, कृपया पहले सब्सक्राइब करें।',
    Accessdeniedfortheunauthorizedrequest: 'अनधिकृत अनुरोध के लिए प्रवेश निषेध।',
    Alreadyhaveaccount: 'पहले से ही खाता है?',
    SignUpwithemail: 'इमेल के साथ हस्ताक्षर करें',
    Securityverification: 'सुरक्षा परीक्षण',
    Pleaseenterthecorrectemailaddress: 'कृपया सही ईमेल पता भरें!',
    PleaseInputverificationCode: 'कृपया सत्यापन कोड इनपुट करें!',
    Pleaseenterthesamepasswordinbothfields: 'कृपया दोनों क्षेत्र में उसी पासवर्ड भरें!',
    or: 'अथवा',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'आपके द्वारा डाला गया नया पासवर्ड आपके पुराने पासवर्ड के समान है। अलग पासवर्ड डालें',
    YourpasswordwasincorrectPleasetryagain: 'आपका पासवर्ड गलत है। कृपया दोबारा कोशिश करें।',
    reg400: 'माफ़ करें, कुछ गड़बड़ हो गयी थी, कृपया बाद में दोबारा कोशिश करें।',
    reg400223: 'इमेल तथा कोड मेल नहीं है, कृपया जाँचें',
    reg400224: 'टोकन मियाद समाप्त है',
    500: 'सर्वर साइड त्रुटि!',
    Afewsecondsaway: 'कुछ सेकंड दूर',
    ContinuewithGoogle: 'Google के साथ जारी रखें',
    ContinuewithEmail: 'ईमेल के साथ जारी रखें',
    LoginwithEmail: 'ईमेल से लॉग इन करें',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        'मिश्रित अक्षरों, संख्याओं और प्रतीकों के साथ 8 से अधिक वर्णों का उपयोग करें (समर्थन करने वाले प्रतीक:@$!%*#_~?&^)',
    ConfirmPassword: 'पासवर्ड की पुष्टि कीजिये',
    Pleaseloginwithemail: 'कृपया ईमेल से लॉग इन करें',
    youraccount: 'आपका खाता',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        ' पहले से मौजूद है, अपने खाते की सुरक्षा सुनिश्चित करने के लिए, कृपया पहले सत्यापन पूरा करें।',
    Login: 'लॉग इन करें',
    exceed6Times: 'तुमची चाचणी आज संपली आहे, कृपया सर्व प्रीमियम वैशिष्ट्यांमध्ये प्रवेश करण्यासाठी Pro वर श्रेणीसुधारित करा.',
    exceed20M: 'विनामूल्य खात्यांसाठी फाइल आकार 20MB पेक्षा जास्त असू शकत नाही, कृपया सर्व प्रीमियम वैशिष्ट्यांमध्ये प्रवेश करण्यासाठी Pro वर श्रेणीसुधारित करा.'
}